import styled from 'styled-components';

export const StyledBanner = styled.div`
  align-items: center;
  background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg[7]};
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
  display: flex;
  font-size: 14px;
  gap: 16px;
  justify-content: center;
  padding: 12px 24px;
  width: 100%;
  z-index: 2000;
`;

export const StyledRefreshButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 4px 12px;

  &:hover {
    background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg1[6]};
  }
`;
